module.exports = __webpack_public_path__ + "3a2f5fe8257d0f287c5efb4cba9b641e.svg";